/** Founding Source */

export const CREATE_FUNDING_SOURCE = 'CREATE_FUNDING_SOURCE';

export const EDIT_FUNDING_SOURCE = 'EDIT_FUNDING_SOURCE';

export const GET_FUNDING_SOURCE = 'GET_FUNDING_SOURCE';
export const GET_FUNDING_SOURCE_SUCCESS = 'GET_FUNDING_SOURCE_SUCCESS';

export const GET_FUNDING_SOURCE_BY_ID = 'GET_FUNDING_SOURCE_BY_ID';
export const GET_FUNDING_SOURCE_BY_ID_SUCCESS = 'GET_FUNDING_SOURCE_BY_ID_SUCCESS';

export const CHANGE_FUNDING_SOURCE_STATUS = 'CHANGE_FUNDING_SOURCE_STATUS';
export const DELETE_FUNDING_SOURCE = 'DELETE_FUNDING_SOURCE';

export const GET_FUNDING_SOURCE_CLIENTS = 'GET_FUNDING_SOURCE_CLIENTS';
export const GET_FUNDING_SOURCE_CLIENTS_SUCCESS = 'GET_FUNDING_SOURCE_CLIENTS_SUCCESS';
export const EDIT_FS_SOURCE_GROUPING = 'EDIT_FS_SOURCE_GROUPING';

export const GET_PAYER_CAPABILITIES = 'GET_PAYER_CAPABILITIES';
export const GET_PAYER_CAPABILITIES_SUCCESS = 'GET_PAYER_CAPABILITIES_SUCCESS';
/** End */

/** Founding Source Service */

export const GET_FUNDING_SOURCE_SERVICE_BY_ID = 'GET_FUNDING_SOURCE_SERVICE_BY_ID';
export const GET_FUNDING_SOURCE_SERVICE_BY_ID_SUCCESS = 'GET_FUNDING_SOURCE_SERVICE_BY_ID_SUCCESS';

export const CREATE_FUNDING_SOURCE_SERVICE_BY_ID = 'CREATE_FUNDING_SOURCE_SERVICE_BY_ID';

export const EDIT_FUNDING_SOURCE_SERVICE = 'EDIT_FUNDING_SOURCE_SERVICE';

export const CHANGE_FUNDING_SOURCE_SERVICE_STATUS = 'CHANGE_FUNDING_SOURCE_SERVICE_STATUS';
export const REMOVE_FUNDING_SOURCE_SERVICES = 'REMOVE_FUNDING_SOURCE_SERVICES';

/** End */

/** Modifiers */

export const GET_FUNDING_MODIFIERS = 'GET_FUNDING_MODIFIERS';
export const GET_FUNDING_MODIFIERS_SUCCESS = 'GET_FUNDING_MODIFIERS_SUCCESS';

export const CREATE_FUNDING_MODIFIER = 'CREATE_FUNDING_MODIFIER';

export const EDIT_FUNDING_MODIFIER = 'EDIT_FUNDING_MODIFIER';

export const CHANGE_FUNDING_MODIFIER_STATUS = 'CHANGE_FUNDING_MODIFIER_STATUS';

/** End */

/** Set Status */

export const SET_STATUS = 'SET_STATUS';

/** Supervision */
export const EDIT_SUPERVISION_REQUIREMENT = 'EDIT_SUPERVISION_REQUIREMENT';

/** CMS 1500 Settings */
export const EDIT_CMS1500_SETTINGS = 'EDIT_CMS1500_SETTINGS';

/** Enrollment */
export const ADD_PAYER_ENROLLMENT = 'ADD_PAYER_ENROLLMENT';
export const CHANGE_PAYER_ENROLLMENT_STATUS = 'CHANGE_PAYER_ENROLLMENT_STATUS';


export const GET_FUNDING_UNIQUE_SERVICES = 'GET_FUNDING_UNIQUE_SERVICES';
export const GET_FUNDING_UNIQUE_SERVICES_SUCCESS = 'GET_FUNDING_UNIQUE_SERVICES_SUCCESS';
